import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { ReactComponent as LinkedInIcon } from '../../../assets/img/icn-linkedin.svg';
import ProfilePhoto from '../../../components/ProfilePhoto';
import { styles } from '../../../styles/themes/style';

interface ILinkedInProfileAvatarProps {
    profilePicture?: string;
    capitalLetters?: string;
    className?: string;
}

/** Figma: 40px avatar + 20px LinkedIn badge overlapping bottom-right (49×40 container). */
const LinkedInProfileAvatar: FunctionComponent<ILinkedInProfileAvatarProps> = ({
    profilePicture,
    capitalLetters,
    className,
}) => (
    <AvatarWrap className={className}>
        <AvatarImage>
            <ProfilePhoto
                source={profilePicture}
                capitalLetters={capitalLetters}
                allowTooltip={false}
                width="40px"
                height="40px"
                minWidth="40px"
                minHeight="40px"
            />
        </AvatarImage>
        <AvatarBadge aria-hidden>
            <LinkedInIcon />
        </AvatarBadge>
    </AvatarWrap>
);

const AvatarWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    flex-shrink: 0;
    width: 49px;
    height: 40px;
`;

const AvatarImage = styled.div`
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    margin-right: -11px;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid ${styles.colors.black200};
    box-sizing: border-box;

    img,
    span {
        width: 40px !important;
        height: 40px !important;
        min-width: 40px;
        min-height: 40px;
        border-radius: 50%;
        display: block;
        object-fit: cover;
    }
`;

const AvatarBadge = styled.div`
    position: relative;
    z-index: 1;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    border-radius: 50%;
    background: ${styles.colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0 1px ${styles.colors.black200};

    svg {
        width: 12px;
        height: 12px;
    }
`;

export default LinkedInProfileAvatar;
